<div class="kpi-dialog">
  <h3 class="kpi-dialog-title">Add Group Function</h3>
  <p class="kpi-dialog-kpi">
    <span class="kpi-dialog-code">{{ MersyId }}</span>
    {{ KpiName }}
  </p>
  <p class="kpi-dialog-text">Please select available Group Functions to be added</p>

  <app-check-list
    [(ngModel)]="SelectedGF"
    [items]="GroupFunctionOptions"
    bindLabel="value"
    bindValue="value"
    ariaLabel="Available Group Functions"
    emptyText="All Group Functions are already assigned">
  </app-check-list>

  <div class="kpi-dialog-actions">
    <button type="button" mat-raised-button class="btn button-color-fix_red" (click)="onNoClick()">
      <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
      Back
    </button>
    <button type="button" mat-raised-button class="btn button-color-fix" [disabled]="SelectedGF.length === 0" (click)="onSubmit()">
      Add {{ SelectedGF.length > 0 ? '(' + SelectedGF.length + ')' : '' }}
      <mat-icon class="icon-color-fix">save</mat-icon>
    </button>
  </div>
</div>
